module.exports = __webpack_public_path__ + "static/img/isPartTime.85d62280.png";